export class BoardSpecificFormDecisionDetails {
    action: string;
    boardType: string;
    closureReason: string;
    decision: string;
}